<template>
  <div class="hasBeenStored">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItemScan" @click="onScan">
          <van-image width="25" height="25" :src="scanIcon"></van-image>
        </van-col>
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
      :ellipsis="false"
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div class="list-container" v-for="(item, index) in tableData" :key="index">
            <div class="checkBox">
              <van-checkbox
                v-model="item.IsChecked"
                @change="handleCheckBox"
              ></van-checkbox>
            </div>
            <div class="container">
              <div class="left">
                <div class="list-item">
                  {{ $t.onlineOrder.postNumber }}：{{ item.ExpressNumber }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.goodsName }}：{{ item.CargoName }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.goodsValue }}：{{ item.GoodsValue }}
                  {{ item.Currency }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.cargoQuantity }}：{{ item.CargoQuantity }}
                  {{ item.QuantityUnit }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.cargoTrackingNumber }}：{{ item.CargoTrackingNumber }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.customerNumber }}：{{ item.CustomerNumber }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.customerName }}：{{ item.CustomerName }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.countryName }}：{{ item.CountryName }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.cargoCategorySn }}：{{ item.CargoCategory }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.storageTime }}：{{ item.StorageTime }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.numberPackages }}：{{ item.NumberPackages }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.volume }}：{{ item.Volume }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.weight }}：{{ item.Weight }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.isUnpack }}：
                  <van-icon name="success" v-if="item.IsUnpack" />
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.taxFeebearingParty }}：
                  <span v-if="item.TaxFeebearingParty == 1">{{
                    $t.onlineOrder.shipperSn
                  }}</span>
                  <span v-if="item.TaxFeebearingParty == 2">{{
                    $t.onlineOrder.consigneeSn
                  }}</span>
                </div>
              </div>
              <div class="right">
                <div class="images">
                  <van-image
                    width="88"
                    height="88"
                    fit="cover"
                    @click="imagePreview(item.ProductPictureList)"
                    :src="imgUrlFilter(item.ProductPictureList[0])"
                    v-if="item.ProductPictureList && item.ProductPictureList.length > 0"
                  />
                  <span v-else>{{ $t.onlineOrder.noImage }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <van-field
          clickable
          readonly
          :value="selectedCountry.text"
          :label="$t.onlineOrder.countryName"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showHasBeenStoredCountry', 1)"
        />

        <van-field
          clickable
          readonly
          :value="selectedService.text"
          :label="$t.onlineOrder.cargoCategorySn"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showHasBeenStoredService', 1)"
        />
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <option-list
      event="showHasBeenStoredCountry"
      :options="countryList"
      @onSelect="countryConfirm"
    ></option-list>

    <option-list
      event="showHasBeenStoredService"
      :options="freightList"
      @onSelect="freightConfirm"
    ></option-list>

    <van-action-sheet
      v-model="moreSheetShow"
      :actions="moreSheetActions"
      @select="moreSheetSelect"
    />

    <van-dialog
      :title="$t.onlineOrder.generateWaybill"
      width="90%"
      v-model="dialogVisible"
      @cancel="dialogVisible = false"
      @confirm="dialogConfirm"
      :cancel-button-text="$t.meta.close"
      :confirm-button-text="$t.meta.confirm"
      :show-cancel-button="true"
      :show-confirm-button="true"
      :before-close="
        (action, done) => {
          done(false);
        }
      "
    >
      <slot name="default">
        <div class="hasBeenStored-alert">
          <van-form label-width="100px">
            <van-field
              required
              clickable
              readonly
              :value="dialogForm.selectedCountry.text"
              :label="$t.onlineOrder.countryName"
              :placeholder="$t.meta.select"
              @click="onShowEmit('showHasBeenStoredCountry', 2)"
            />

            <van-field
              required
              clickable
              readonly
              :value="dialogForm.selectedService.text"
              :label="$t.onlineOrder.cargoCategorySn"
              :placeholder="$t.meta.select"
              @click="onShowEmit('showHasBeenStoredService', 2)"
            />
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <div class="tool-bar">
      <van-button
        type="info"
        class="submit-button"
        block
        :disabled="checkedList.length == 0 ? true : false"
        @click="gotoWayBill"
        >{{ $t.onlineOrder.outbound }}</van-button
      >
      <van-button class="more-button" @click="handleMoreSheetShow">{{
        $t.meta.more
      }}</van-button>
    </div>
  </div>
</template>

<script>
import OptionList from "@components/optionList/OptionList.vue";
import {
  List,
  Tab,
  Tabs,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Popup,
  Picker,
  Radio,
  RadioGroup,
  Checkbox,
  Image,
  Icon,
  ActionSheet,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Tab)
  .use(Tabs)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Picker)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(Image)
  .use(Icon)
  .use(ActionSheet);

export default {
  name: "hasBeenStored",
  components: {
    OptionList,
  },
  data() {
    return {
      scanIcon: require("@/assets/img/home/scan.png"),
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.onlineOrder.tab1,
          name: 1,
          count: 0,
        },
      ],
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.onlineOrder.postNumber,
          value: 1,
        },
        {
          text: this.$t.onlineOrder.goodsName,
          value: 2,
        },
        {
          text: this.$t.onlineOrder.customerNumber,
          value: 3,
        },
        {
          text: this.$t.onlineOrder.customerName,
          value: 4,
        },
      ],
      showFilter: false,
      selectedType: 1,
      selectedCountry: { text: "", value: null },
      selectedService: { text: "", value: null },
      countryList: [],
      freightList: [],
      //picker
      showHasBeenStoredCountry: false,
      showHasBeenStoredService: false,
      //多选
      checkedList: [],
      //更多
      moreSheetShow: false,
      moreSheetActions: [],
      dialogVisible: false,
      dialogForm: {
        selectedCountry: { text: "", value: null },
        selectedService: { text: "", value: null },
      },
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
    $route(to, from) {
      if (this.$route.query && to && from) {
        const { SearchText } = this.$route.query;
        if (SearchText) {
          this.searchText = SearchText;
          this.loading = true;
          this.finished = false;
          this.error = false;
          this.tableData = [];
          this.getList(1);
        }
      }
    },
  },
  created() {
    this.getCustomerOrderAlreadyInStorageCountryListByOrderState();
  },
  methods: {
    onScan() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.scanToPage, {
        options: {
          baseColor: "#009ed4",
          choosePhotoEnable: "true",
          flashlightEnable: "true",
          title: this.$t.onlineOrder.scanTitle1,
          describe: this.$t.meta.scanDes,
          choosePhotoBtnTitle: this.$t.meta.scanButton,
        },
        path: "hasBeenStored",
        errorText: this.$t.meta.scanError1,
        authText: this.$t.meta.scanError2,
      });
    },
    dialogConfirm() {
      if (!this.dialogForm.selectedCountry.value) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.meta.select + " " + this.$t.onlineOrder.countryName,
          type: "error",
        });
        return;
      }
      if (!this.dialogForm.selectedService.value) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.meta.select + " " + this.$t.onlineOrder.cargoCategorySn,
          type: "error",
        });
        return;
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "hasBeenStoredDetail",
        name: "hasBeenStoredDetail",
        query: [
          {
            name: "FPId",
            value: this.dialogForm.selectedCountry.value,
          },
          {
            name: "FPDId",
            value: this.dialogForm.selectedService.value,
          },
        ],
      });
    },
    moreSheetSelect(e) {
      if (e.className == "1") {
        this.dialogForm.selectedCountry = { text: "", value: null };
        this.dialogForm.selectedService = { text: "", value: null };
        this.dialogVisible = true;
      }
      this.moreSheetShow = false;
    },
    handleMoreSheetShow() {
      var actions = [];
      actions = [
        {
          name: this.$t.onlineOrder.generateWaybill,
          className: "1",
        },
      ];

      this.moreSheetActions = actions;
      this.moreSheetShow = true;
    },
    gotoWayBill() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "buildWayBillNo",
        name: "buildWayBillNo",
        query: [
          {
            name: "COIds",
            value: this.checkedList,
          },
          {
            name: "state",
            value: 5,
          },
        ],
      });
    },
    handleCheckBox() {
      var list = [];
      var items = this.tableData.filter((p) => p.IsChecked);
      for (var item of items) {
        list.push(item.COId);
      }
      this.checkedList = list;
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      var pictureList = [];
      for (var image of images) {
        pictureList.push(this.imgUrlFilter(image));
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: pictureList,
        startPosition: 0,
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.selectedCountry.value || this.selectedService.value) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.selectedCountry = { text: "", value: null };
      this.selectedService = { text: "", value: null };
      this.freightList = [];
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    pickerShow(pickerName) {
      this[pickerName] = true;
    },
    countryConfirm(e) {
      if (this.selectedType == 1) {
        this.selectedCountry.text = e.text;
        this.selectedCountry.value = e.value;
        this.selectedService = { text: "", value: null };
      }
      if (this.selectedType == 2) {
        this.dialogForm.selectedCountry.text = e.text;
        this.dialogForm.selectedCountry.value = e.value;
        this.dialogForm.selectedService = { text: "", value: null };
      }
      this.showHasBeenStoredCountry = false;
      this.getFreightPriceDetailListByOrderStateAndFPId(e.value);
      this.$forceUpdate();
    },
    freightConfirm(e) {
      if (this.selectedType == 1) {
        this.selectedService.text = e.text;
        this.selectedService.value = e.value;
      }
      if (this.selectedType == 2) {
        this.dialogForm.selectedService.text = e.text;
        this.dialogForm.selectedService.value = e.value;
      }
      this.showHasBeenStoredService = false;
      this.$forceUpdate();
    },
    getCustomerOrderAlreadyInStorageCountryListByOrderState() {
      return new Promise((resolve) => {
        this.$api.onlineOrderManagement
          .getCustomerOrderAlreadyInStorageCountryListByOrderState()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName,
                value: item.FPId,
                rightText: item.HasPutInStorageCount,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getFreightPriceDetailListByOrderStateAndFPId(id) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        var param = {
          FPId: id,
        };
        this.$api.onlineOrderManagement
          .getFreightPriceDetailListByOrderStateAndFPId(param)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CargoCategory,
                value: item.FPDId,
                rightText: item.HasPutInStorageCount,
              };
              result.push(data);
            });
            this.freightList = result;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onShowEmit(emit, type) {
      this.selectedType = type;
      this.$bus.$emit(emit, true);
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      this.searchText = "";
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        ExpressNumber: this.searchType == 1 ? this.searchText : "",
        CargoName: this.searchType == 2 ? this.searchText : "",
        CustomerNumber: this.searchType == 3 ? this.searchText : "",
        CustomerName: this.searchType == 4 ? this.searchText : "",
        FPId: this.selectedCountry.value,
        FPDId: this.selectedService.value,
      };
      var request = null;
      if (this.menuState == 1) {
        request = this.$api.onlineOrderManagement.getCustomerOrderAlreadyInStorageListByPage(
          param
        );
      }
      request
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.hasBeenStored {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItemScan {
        width: 15%;
        margin: auto;
        text-align: center;
        .van-icon {
          color: #323233;
          font-weight: bold;
        }
      }
      .colItem1 {
        width: 65%;
        text-align: center;
        font-size: 14px;
        .van-search {
          padding: 10px 0px;
          .van-search__content {
            padding: 0px;
            margin-right: 10px;
            .van-cell {
              padding: 5px 8px 5px 8px;
            }
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      .checkBox {
        vertical-align: middle;
        display: inline-block;
        margin: 15px;
      }
      .container {
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
        padding: 10px;
        .left {
          vertical-align: middle;
          display: inline-block;
          width: 60%;
          .list-item {
            margin-bottom: 10px;
            .van-icon-success {
              color: #01aaa3;
              font-size: 14px;
            }
          }
          .list-item:last-child {
            margin-bottom: 0px;
          }
        }
        .right {
          vertical-align: middle;
          display: inline-block;
          width: 40%;
          .images {
            overflow: hidden;
            vertical-align: middle;
            text-align: center;
            ::v-deep img {
              border-radius: 8px;
            }
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .hasBeenStored-alert {
    overflow: scroll;
    margin-top: 30px;
    margin-bottom: 30px;
    .van-form {
      padding-bottom: 0px !important;
    }
    .multi-table {
      .multi-table-header {
        padding: 10px 15px;
        .multi-table-title {
          font-size: 14px;
          color: #999;
          display: inline-block;
          vertical-align: middle;
        }
        .multi-table-btn {
          font-size: 20px;
          color: #000;
          width: 100%;
          display: inline-block;
          text-align: right;
          vertical-align: middle;
        }
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .submit-button {
      width: 70%;
      border: none;
      border-radius: 0px;
      display: inline-block;
    }
    .more-button {
      background: #5029c3;
      color: #fff;
      border: none;
      border-radius: 0px;
      display: inline-block;
      width: 30%;
    }
  }
}
</style>
